import "./fieldGuide/critter.scss";

/*
<img src="{{ image.thumb.url }}"
                   class="lightbox__thumbImg"
                   width="{{ image.thumb.width }}"
                   height="{{ image.thumb.height }}"
                   data-fill-image="{{ image.large|json_encode }}"
                   data-caption="{{ image.caption }}" />
 */
//lightbox
const lightboxes = document.querySelectorAll(".lightbox");
lightboxes.forEach((lightbox) => {
  const mainImageWrapper = lightbox.querySelector(".lightbox__main");
  const mainImageContainer = lightbox.querySelector(".lightbox__mainContainer");
  const mainImage = mainImageWrapper.querySelector("img");
  const mainImageCaption = mainImageWrapper.querySelector("figcaption");

  const thumbs = lightbox.querySelectorAll(".lightbox__thumb");
  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", (e) => {
      const img = thumb.querySelector("img");
      const atts = JSON.parse(img.dataset.fillImage);
      const caption = img.dataset.caption;

      //load new image
      const newImg = new Image();
      newImg.onload = function () {
        mainImage.src = atts.url;
        mainImageContainer.style = `--mainImage: url(${atts.url})`;
        mainImage.width = atts.width;
        mainImage.height = atts.height;
        mainImage.alt = atts.alt;
        mainImageCaption.innerHTML = JSON.parse(caption);
        thumbs.forEach((t) => {
          t.ariaCurrent = "false";
        });
        thumb.ariaCurrent = "true";
      };
      newImg.src = atts.url;
    });
  });
});
